import $ from 'jquery';
import debounce from 'lodash.debounce';

let nav = function Subnav(options) {
  let pub = {};
  let priv = $.extend({container: document}, options);
  priv.$container = $(priv.container);

  /**
   *
   * @returns {{}}
   */
  priv.init = function init() {
    if (priv.$container.length) {
      priv.$sub = priv.$container.find('#sub-header');
      priv.$overflowTrigger = priv.$container.find('.overflow-trigger');
      priv.$overflowMobileLabel = priv.$container.find('.overflow-label-mobile');
      priv.attachHandlers();
    }

    return pub;
  };

  /**
   *
   * @param $nav
   * @returns {array}
   */
  priv.computeOverflowBreakpoints = function computeOverflowBreakpoints($nav) {

    // Get a list of the nav items
    let $items = $nav.find('li');

    // Accumulator for tracking when subnav elements should fall into off
    // into the overflow menu
    let accumulatedWidth = 0;

    // Map the item list into a list of widths and return
    return $items.toArray().map(function(item, i) {

      // Fix the last two non-overflow-trigger elements to the same point
      // so that there is never a case where there is a single element in
      // the overflow menu
      if (i < $items.length - 1) {
        accumulatedWidth += item.offsetWidth;
      }

      return accumulatedWidth;
    });
  };

  /**
   *
   * @param $nav
   * @returns {number}
   */
  priv.computeOverflowTriggerSpace = function($nav) {
    let $items = $nav.find('li');
    let $overflowTrigger = $items.last();

    return $overflowTrigger[0].offsetWidth + 30;
  };

  /**
   *
   * @param $header
   * @returns {Function}
   */
  priv.subnavWidthHandler = function subnavWidthHandler($header) {
    if (!$header) {
      return function() {};
    }

    let $navs = $header.find('.sub-navigation');

    if (!$navs.length) {
      return function() {};
    }

    // Compute the overflow widths from the first instance as it is the only
    // visible version that can be measured
    let breakpoints = priv.computeOverflowBreakpoints($navs.first());

    // Compute the size of the overflow trigger
    let triggerWidth = priv.computeOverflowTriggerSpace($navs.first());

    let handlers = $navs.toArray().map(function(nav) {

      let $nav = $(nav);
      let $items = $nav.find('li');
      let $overflowMenu = $header.find('.overflow-wrapper');
      let $overflowMenuItems = $overflowMenu.find('li');
      let $overflowTrigger = $items.last();

      if (!$overflowTrigger.length) {
        return function() {};
      }

      $items.each(function(i, item) {
        $(item).attr('data-overflow', breakpoints[i]);
      });

      // Define helper functions
      let hide = function hide(elm) {
        elm.classList.add('hide');
      };

      let show = function show(elm) {
        elm.classList.remove('hide');
      };

      return function() {
        let width = document.documentElement.clientWidth;

        if (document.documentElement.clientWidth > 640) {
          let hasOverflown = false;

          $items.each(function(index, item) {
            if (index < $items.length - 1) {
              if (width < ($items[index + 1].dataset.overflow|0) + triggerWidth) {
                hasOverflown = true;

                // Only perform operations when necessary, these are expensive
                if (!item.classList.contains('hide')) {
                  requestAnimationFrame(function () {
                    hide(item);
                    show($overflowMenuItems[index]);
                  });
                }
              } else {

                // Only perform operations when necessary, these are expensive
                if (item.classList.contains('hide')) {
                  requestAnimationFrame(function () {
                    show(item);
                    hide($overflowMenuItems[index]);
                  });
                }
              }
            }
          });

          if (hasOverflown) {
            if ($overflowTrigger[0].classList.contains('hide')) {
              requestAnimationFrame(function () {
                show($overflowTrigger[0]);
              });
            }
          } else {
            if (!$overflowTrigger[0].classList.contains('hide')) {
              requestAnimationFrame(function () {
                hide($overflowTrigger[0]);
              });
            }
          }
        }
      };
    });

    return function() {
      handlers.forEach(function(handler) {
        handler();
      });
    };
  };

  /**
   * @param $header
   * @returns {Function}
   */
  priv.subnavStickynessHandler = function subnavStickynessHandler($header) {
    if (!$header.length || document.documentElement.clientWidth < 641) {
      return function() {};
    }

    let $subExtraWrapper = $header.find('.subnav-extra-wrapper').first();
    let $subExtra = $subExtraWrapper.find('.subnav-extra').first();
    let $logo = $header.find('.subnav-logo').first();
    let $title = $header.find('.subnav-title').first();
    let $stickyNav = $header.find('.sticky').first();
    let distance = $subExtra[0].offsetHeight;

    if (!$subExtraWrapper.length) {
      return function() {};
    }

    let transition = function transition(progress) {
      $header.removeClass('sticky');
      $stickyNav.removeClass('show');
      $subExtraWrapper[0].style.background = 'rgba(255, 255, 255, ' + progress + ')';

      if ($logo.length) {
        $logo[0].style.opacity = progress;
      }

      if ($title.length) {
        $title[0].style.opacity = progress;
      }
    };

    let stick = function stick(progress) {
      $header.addClass('sticky');
      $stickyNav.addClass('show');
      $subExtraWrapper[0].style.background = 'rgba(255, 255, 255, ' + progress + ')';

      if ($logo.length) {
        $logo[0].style.opacity = 0;
      }

      if ($title.length) {
        $title[0].style.opacity = 0;
      }
    };

    return function() {
      let scrollProgress = 1 - Math.min(1, Math.max(0, window.scrollY / distance));

      if (scrollProgress === 0) {
        requestAnimationFrame(function() {
          stick(scrollProgress);
        });
      } else {
        requestAnimationFrame(function() {
          transition(scrollProgress);
        });
      }
    }
  };

  /**
   * Create a binding function that can be repeatably called to bind the sticky scroll handler
   */
  priv.scrollBinder = function scrollBinder() {

    // Remove any existing handlers
    if (priv.scrollHandler) {
      window.removeEventListener('scroll', priv.scrollHandler);
    }

    // Compute a handler
    priv.scrollHandler = priv.subnavStickynessHandler(priv.$sub);

    // Trigger an initial call to the handler as soon as possible
    priv.scrollHandler();

    // Then attach to the scroll event for later
    window.addEventListener('scroll', priv.scrollHandler);
  };

  /**
   *
   */
  priv.attachHandlers = function attachHandlers() {

    // Make an initial call to the scrollBinder
    priv.scrollBinder();

    // Listen for resizes to determine when to recalculate the scroll handler
    window.addEventListener('resize', debounce(priv.scrollBinder, 500));

    // After images load the scroll bind may need to be recomputed
    $(document).ready(priv.scrollBinder);

    // Generate the resize handler
    let subSizeHandler = priv.subnavWidthHandler(priv.$sub);

    // Make an initial call to the sizer
    subSizeHandler();

    // Bind the handler to resize
    window.addEventListener('resize', debounce(subSizeHandler, 250));

    // Handler for mobile sub-nav.
    if (priv.$overflowTrigger) {
      priv.$overflowTrigger.each(function(index, trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          $(this).parents('#sub-header').toggleClass('overflow-active');
        });
      });
    }
  };

  /**
   * Gets the height of the navigation elements bar
   * @returns {number}
   */
  pub.getHeight = function getHeight() {
    let $nav = priv.$container.find('.sub-navigation').first();
    return ($nav.length && $nav[0].offsetHeight) || 0;
  };

  pub.setMobileSelectionLabel = function setMobileSelectionLabel(label) {
    priv.$overflowMobileLabel.each(function(index, elm) {
      elm.innerHTML = label;
    });
  };

  return priv.init();
};

export default nav();